import script from "./monitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./monitoring.vue?vue&type=script&setup=true&lang=js"

import "./monitoring.vue?vue&type=style&index=0&id=3074c7e2&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3074c7e2"]])

export default __exports__